import { render, staticRenderFns } from "./ModalEnviarEmail.vue?vue&type=template&id=45909635"
import script from "./ModalEnviarEmail.vue?vue&type=script&lang=js"
export * from "./ModalEnviarEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports